import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Apply from "@/pages/Apply";
import Contact from "@/pages/Contact";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookieConsent from "@/components/CookieConsent";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <SmoothScroll>
      <div className="grain min-h-screen">
        <Navbar />
        <main>{children}</main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <ScrollTop />
            <Toaster theme="dark" position="top-center" richColors />
            <Routes>
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
              <Route path="/a-propos" element={<PublicLayout><About /></PublicLayout>} />
              <Route path="/offres" element={<PublicLayout><Jobs /></PublicLayout>} />
              <Route path="/offres/:id" element={<PublicLayout><JobDetail /></PublicLayout>} />
              <Route path="/candidature" element={<PublicLayout><Apply /></PublicLayout>} />
              <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
              <Route path="/politique-confidentialite" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <CookieConsent />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
